import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
  useMediaQuery
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PropTypes from 'prop-types';
import IframeComponent from './IframeComponent'; // Import the iframe component

const CourseCard2 = ({ id, session, onReportClick }) => {
  const matches = useMediaQuery('(min-width:600px)');
  const [expanded, setExpanded] = useState(false);
  const [selectedMode, setSelectedMode] = useState(null);

  const handleExpand = () => setExpanded(prev => !prev);

  const handleReportClick = mode => {
    // Set the selected mode to render the iframe
    setSelectedMode(mode);
    if (onReportClick) {
      onReportClick(mode, session); // Trigger callback if provided
    }
  };

  const handleBack = () => {
    setSelectedMode(null); // Navigate back to the course card
  };

  localStorage.setItem('courseIdselected', id);

  // Report modes
  const reports = [
    { title: 'Average Timing Report', mode: 'avgtiming' },
    { title: 'Document Performance Report', mode: 'document' },
    { title: 'Prescriptive Analysis Report', mode: 'prescriptive' },
    { title: 'Timing Performance Report', mode: 'timingperf' },
    { title: 'View Submissions', mode: 'submissions' },
    { title: 'Progress Report', mode: 'progress' }
  ];

  if (selectedMode) {
    // Render IframeComponent for all modes
    return <IframeComponent mode={selectedMode} session={session} onBack={handleBack} />;
  }

  return (
    <Accordion
      expanded={expanded}
      onChange={handleExpand}
      sx={{
        backgroundColor: '#F7F9FC',
        boxShadow:
          '0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem rgb(195 193 198 / 90%)',
        marginBottom: '20px',
        borderRadius: '10px'
      }}>
      <AccordionSummary
        expandIcon={
          expanded ? (
            <ExpandLessIcon fontSize={matches ? 'large' : 'medium'} />
          ) : (
            <ExpandMoreIcon fontSize={matches ? 'large' : 'medium'} />
          )
        }
        sx={{
          padding: '15px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
        <Typography
          sx={{
            fontSize: matches ? '25px' : '15px',
            marginLeft: '20px',
            textShadow: '3px 3px 8px rgb(163,177,198,.7), -3px -3px 8px rgba(255,255,255, 1)',
            fontWeight: 'bold',
            textTransform: 'uppercase'
          }}
          color="GrayText">
          {session}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {reports.map((report, index) => (
            <ListItem
              key={index}
              sx={{
                padding: '10px 20px',
                borderBottom: '1px solid #ddd',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline',
                  color: '#007BFF'
                }
              }}
              onClick={() => handleReportClick(report.mode)} // Handle report click
            >
              <Typography
                sx={{
                  fontSize: matches ? '18px' : '14px',
                  fontWeight: 'bold',
                  color: '#333'
                }}>
                {report.title}
              </Typography>
            </ListItem>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  );
};

CourseCard2.propTypes = {
  id: PropTypes.string.isRequired, // Session name
  session: PropTypes.string.isRequired, // Session name
  onReportClick: PropTypes.func // Callback for report click
};

export default CourseCard2;
